import React, { Component } from 'react';
import ReactDOM from "react-dom";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { sectionStatusIconClass } from '../Sections/Helper';
import { NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
// import { arrayOfDeffered } from 'redux-saga/utils';

const portal = document.createElement("div");
portal.classList.add("my-super-portal");

if (!document.body) {
  throw new Error("body not ready for portal creation!");
}

document.body.appendChild(portal);

// fake data generator
/* const getItems = count =>
  Array.from({ length: count }, (v, k) => k).map(k => ({
    id: `item-${k}`,
    content: `item ${k}`
  })); */

// a little function to help us with reordering the result
const reorder = (sections, startIndex, endIndex) => {
  const result = Array.from(sections);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

const grid = 2;

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  padding: grid,
  margin: `0 0 ${grid}px 0`,

  // change background colour if dragging
  background: isDragging ? "lightgray" : "white",

  // styles we need to apply on draggables
  ...draggableStyle
});

const getListStyle = isDraggingOver => ({
  // background: isDraggingOver ? "lightblue" : "#90d4ee",
  padding: 0,
  width: '100%',
  height: 520,
  overflowY: 'scroll'
});

class SectionRearrange extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: props.sectionData
    };
    this.onDragEnd = this.onDragEnd.bind(this);
  }
  componentDidUpdate(prevProps) {
    if (this.props.sectionData !== prevProps.sectionData) {
      this.setState({
        items: this.props.sectionData
      })
    }
  }
  onDragEnd(result) {
    if (this.props.isDragDisabled) {
      return;
    }
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const items = reorder(
      this.state.items,
      result.source.index,
      result.destination.index
    );
    this.setState({
      items
    }, () => {
      this.props.reorder(this.state.items)
    });

  }
  /* handleOrderChange = () => {
    this.props.reorder(this.state.items)
  }

  handleOrderCancel = () => {
    this.props.close()
  } */
  // Normally you would want to split things out into separate components.
  // But in this example everything is just done in one place for simplicity
  render() {
    return (
      <div className="">
        <DragDropContext onDragEnd={this.onDragEnd}>
          <Droppable droppableId="droppable">
            {(provided, snapshot) => (
              <div
                ref={provided.innerRef}
                style={getListStyle(snapshot.isDraggingOver)}
              >
                {this.state.items.map((item, index) => (
                  <Draggable key={item.computedSectionId} draggableId={item.computedSectionId} index={index} isDragDisabled={this.props.isDragDisabled}>
                    {(provided, snapshot) => {
                      const child = (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...(this.props.isDragDisabled ? {} : provided.dragHandleProps)}
                          style={getItemStyle(
                            snapshot.isDragging,
                            provided.draggableProps.style
                          )}
                        >
                          <NavItem key={item.computedSectionId} className='tabs-style'>
                            <NavLink key={item.computedSectionId}
                              className={classnames({ active: this.props.tabData.computedSectionId === item.computedSectionId })}
                              onClick={(e) => this.props.handleToggle(item, item.computedSectionId)}
                            >
                             
                             {item.sectionType!="SYSTEMDEFINED" &&item.taskStatus!="APPROVED"?
                            <input type="checkbox" className="mx-2 align-middle"   onClick={(e) => this.props.handleCheckbox(item, item.computedSectionId)} />
                            :null
                          }

                              <i className={sectionStatusIconClass(item.taskStatus)} title={item.taskStatus}></i>
                              &nbsp; {item.displayName}
                            </NavLink>
                          </NavItem>
                          {/* <b>{item.displayName}</b> */}
                        </div>
                      );

                      const usePortal = snapshot.isDragging;

                      if (!usePortal) {
                        return child;
                      }

                      // if dragging - put the item in a portal
                      return ReactDOM.createPortal(child, portal);
                    }}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
        {/* <button className="btn btn-primary mt-5" onClick={this.handleOrderChange}>OK</button>
        <button className="btn btn-danger mt-5 ml-3" onClick={this.handleOrderCancel}>Cancel</button> */}
      </div>

    );
  }
}



/* const mapDispatchToProps = (dispatch) => {
    return {
        
        rearrangeSections: (newSections) => { dispatch(rearrangeSections(newSections)); }//rearrangeSections
    };
}; */

export default SectionRearrange;